import { isArray, isObject } from "@visactor/vutils";

import { EVENT_SOURCE_VIEW, EVENT_SOURCE_WINDOW } from "./constants";

export function initializeEventConfig(config) {
    const eventsConfig = Object.assign({
        defaults: {}
    }, config), unpack = (obj, keys) => {
        keys.forEach((k => {
            isArray(obj[k]) && (obj[k] = obj[k].reduce(((set, key) => (set[key] = !0, set)), {}));
        }));
    };
    return unpack(eventsConfig.defaults, [ "prevent", "allow" ]), unpack(eventsConfig, [ EVENT_SOURCE_VIEW, EVENT_SOURCE_WINDOW ]), 
    eventsConfig;
}

export function prevent(eventConfig, type) {
    const def = eventConfig.defaults, prevent = def.prevent, allow = def.allow;
    return !1 !== prevent && !0 !== allow && (!0 === prevent || !1 === allow || (prevent ? prevent[type] : !!allow && !allow[type]));
}

export function permit(eventConfig, key, type) {
    const rule = null == eventConfig ? void 0 : eventConfig[key];
    return !(!1 === rule || isObject(rule) && !rule[type]);
}
//# sourceMappingURL=events.js.map
